'use client';

import { useEffect } from 'react';
import { HttpStatusScreen } from '@/components/widget';
import { sanitizePublicText } from '@/lib/sanitizePublicText';

type AppError = Error & { digest?: string };

export default function AppError({ error, reset }: { error: AppError; reset: () => void }) {
  useEffect(() => {
    if (process.env.NODE_ENV !== 'production') {
      console.error('[AppError]', error);
    }
  }, [error]);

  const technicalHint =
    process.env.NODE_ENV !== 'production' ? sanitizePublicText(error.message) : undefined;

  return (
    <HttpStatusScreen
      statusCode={500}
      digest={error.digest}
      technicalHint={technicalHint}
      onReset={reset}
      resetLabel="Try again"
    />
  );
}
